import React from 'react';
import PropTypes from 'prop-types';
import { Panel, Alert, Button } from "react-bootstrap";
import UiUtils from '../../../../utils/UiUtils';
import ApiClient from '../../../../utils/ApiClient';
import ResultadoBusqueda from './components/ResultadoBusqueda';
import ResultadoBusquedaFull from '../../../../components/resultado-busqueda-full/ResultadoBusquedaFull';
import '../../../../css/busqueda.css';
import {
    RESULTS_PER_PAGE
}
from '../../../../config';


class PersonasBusqueda extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tipo: props.tipo,
      valor: props.valor,
      nombre: props.nombre,
      provincia: props.provincia,
      nacionalidad: props.nacionalidad,
      edadgt: props.edadgt,
      edadlt: props.edadlt,
      resultados_busqueda: [],
      totalSize: 0,
      currentPage: 0,
      modo_busqueda: "simple"
    }
  }

  componentDidMount() {
      this.setState({
        modo_busqueda: "simple"
      });
    this.onBusquedaHandler(1);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      tipo: nextProps.tipo,
      valor: nextProps.valor,
      nombre: nextProps.nombre,
      provincia: nextProps.provincia,
      nacionalidad: nextProps.nacionalidad,
      edadgt: nextProps.edadgt,
      edadlt: nextProps.edadlt,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.tipo !== prevState.tipo || this.state.valor !== prevState.valor ||
      this.state.nombre !== prevState.nombre || this.state.provincia !== prevState.provincia ||
      this.state.nacionalidad !== prevState.nacionalidad ||
      this.state.edadgt !== prevState.edadgt || this.state.edadlt !== prevState.edadlt) {
          this.setState({
            modo_busqueda: "simple"
          }, () => {
            this.onBusquedaHandler(1);
            });
      }
  }

  onBusquedaHandler = (page) => {
    UiUtils.showProgress(true);
    ApiClient.searchPerson(this.state.tipo, this.state.valor,
      this.state.nombre,
      this.state.provincia,
      this.state.nacionalidad,
      this.state.edadgt,
      this.state.edadlt, page, RESULTS_PER_PAGE, this.state.modo_busqueda)
      .then(this.onFinishSearch)
      .then((res) => {
        this.setState({
          currentPage: page,
          resultados_busqueda: res.data,
          totalSize: res.total_page
        });
      })
      .catch(function (error) {
        UiUtils.showProgress(false);
        UiUtils.showError(error);
        UiUtils.navigateTo('/dashboard/personas/busqueda/');
      });
  }

  onPageChange = (page, sizePerPage) => {
    this.onBusquedaHandler(page);
  }

    busquedaIntesiva = (e) => {
      this.setState({
        modo_busqueda: "full"
      }, () => {
          this.onBusquedaHandler(1);
      })
    }

  onFinishSearch = (res) => {
    UiUtils.showProgress(false);
    if (res.result.code === 200) {
        return res;
      //if (res.data.length > 0) {
      //} else {
        //throw UiUtils.handledError("No se han encontrado resultados que coincidan con su criterio de búsqueda");
      //}
    } else {
      throw UiUtils.handledError(res.result.info);
    }
  }

  render() {
      const panel_title = (
          <h2><i className="fa fa-search"></i>  Resultados de la búsqueda</h2>
      )

      const resultado_simple = (
          <Panel header={panel_title}>
              <h2>Seleccione la persona que desea buscar</h2>
              <ResultadoBusqueda onResultadoSeleccionado={this.props.onResultadoSeleccionado}
                  datos={this.state.resultados_busqueda} onPageChange={this.onPageChange}
                  currentPage={this.state.currentPage} totalDataSize={this.state.totalSize} />
          </Panel>
  )

      const resultado_full = (
          <Panel header={panel_title}>
              <h2>Seleccione la persona que desea buscar</h2>
              <ResultadoBusquedaFull onResultadoSeleccionado={this.props.onResultadoSeleccionado}
                  datos={this.state.resultados_busqueda} onPageChange={this.onPageChange}
                  currentPage={this.state.currentPage} totalDataSize={this.state.totalSize} />
          </Panel>
      )

      const panel_resultado = (this.state.modo_busqueda == "full") ? resultado_full : resultado_simple;

      const busqueda_vacia = (this.state.resultados_busqueda.length == 0 && this.state.modo_busqueda == 'simple') ? (
          <Alert bsStyle="info" onDismiss={this.handleDismiss}>
              <h4>No encontramos información</h4>
              <p>Cómo no se han encontrado resultados que coincidan con su criterio de búsqueda, podemos hacer una búsqueda más completa, pero puede tardar unos momentos...</p>
              <p>
                  <Button onClick={this.busquedaIntesiva} bsStyle="info">Búsqueda completa</Button>
              </p>
          </Alert>
      ) : (
          <Alert bsStyle="info" onDismiss={this.handleDismiss}>
              <h4>No encontramos información</h4>
              <p>Lamentablemente no hemos encontrado información aun haciendo una busqueda completa</p>
          </Alert>
      )

    const cuerpo = (this.state.resultados_busqueda.length == 0) ? (
        busqueda_vacia
    ) : (
         panel_resultado 
    )

    return (
      <div className="resultado-busqueda -seleccionable">
          <h1>Búsqueda de personas</h1>
          {cuerpo}
      </div>
    );
  }

    static propTypes = {
        onResultadoSeleccionado: PropTypes.func,
        tipo: PropTypes.string.isRequired,
        valor: PropTypes.string.isRequired,
        nombre: PropTypes.any,
        provincia: PropTypes.any,
        nacionalidad: PropTypes.any,
        edadgt: PropTypes.any,
        edadlt: PropTypes.any
    }
}

export default PersonasBusqueda;



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-busqueda/PersonasBusqueda.js